import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.5193 17.2918C16.8566 16.9988 16.9375 16.4951 16.6899 16.1072L16.6086 15.9983C16.3156 15.661 15.8119 15.5801 15.424 15.8277L13.2044 17.2446L13.2044 4.25053L13.196 4.12614C13.1353 3.67872 12.7518 3.33386 12.2877 3.33386C11.7814 3.33386 11.371 3.74427 11.371 4.25053L11.371 17.262L9.06914 15.8232L8.94902 15.7598C8.53953 15.5809 8.04993 15.7241 7.80589 16.1143C7.53744 16.5436 7.66778 17.1091 8.09701 17.3776L11.7973 19.6918C11.9 19.7569 12.0165 19.8022 12.1414 19.8223C12.2379 19.8378 12.3364 19.8379 12.4328 19.8224C12.5607 19.8021 12.6797 19.7553 12.7841 19.688L16.4104 17.3731L16.5193 17.2918Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }